import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import { setAddNewTask } from '../../../../ReduxToolkit/Reducers/TodoReducer';
import { Btn } from '../../../../AbstractElements';

export default function MarkTasks() {
    const dispatch = useDispatch();
    const { allTodos, addNewTask } = useSelector((state: RootState) => state.todos)

    const addNewTaskHandle = () => {
        dispatch(setAddNewTask(!addNewTask))
    };

    
    return (
        <div className="mark-all-tasks">
            <div className="mark-all-tasks-container">
            </div>
            <div className="todo-list-footer ms-2">
                <div className="add-task-btn-wrapper">
                    <Btn color='primary' className={`add-task-btn ${addNewTask ? "hide" : ""}`} onClick={addNewTaskHandle}>
                        <i className="icon-plus" /> {'Add new task'}
                    </Btn>
                </div>
            </div>
        </div>
    )
}